<template>
<!--tabbar-->
    <div style="overflow-y: scroll;height: 100vh;">
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
        :disabled="loading"
      >
        <van-list
          v-if="!nodata"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多数据了"
          @load="onLoad"
        >
          <van-cell-group
            v-for="(item, index) in list"
            :key="index">
            <van-cell :border="false">
              <template #title>
                <span class="item-time">{{item.createTime}}</span>
              </template>
              <template #default>
                <p class="item-type">
                  <span class="dot"></span> {{item.status}}
                </p>
              </template>
            </van-cell>
            <van-cell :border="false" class="item-no" :title="'发货单号：'+item.num"/>
            <van-cell :border="false" class="item-no" :title="'处理网点：'+item.supply_point_name"/>
            <van-cell :border="false" class="item-bd">
              <template #title>
                <div class="custom-title">{{item.consignerName}}</div>
              </template>
              <template #icon>
                <div>
                  <span class="fa"></span>
                </div>
              </template>
              <template #label>
                <div class="custom-default">
                  <span>{{item.consignerAlias}}</span>
                  <!--<span>{{item.consignerAddress}}</span>-->
                  <span>{{item.beginDate}}</span>
                </div>
              </template>
            </van-cell>
            <van-cell :border="false" class="item-bd">
              <template #title>
                <div class="custom-title">{{item.receiverName}}</div>
              </template>
              <template #icon>
                <span class="shou"></span>
              </template>
              <template #label>
                <div class="custom-default">
                  <span>{{item.receiverAlias}}</span>
                  <!--<span>{{item.receiverAddress}}</span>-->
                  <span>{{item.endDate}}</span>
                </div>
              </template>
            </van-cell>
            <van-cell :border="false" class="item-bd" title="">
              <template #label>
                <div class="item-info">
                  <van-row>
                    <van-col span="24">
                      <span>货品名称：</span><span>{{item.supplyTransportGoodsVOList[0].prodName}}</span>
                    </van-col>
                    <van-col span="12">
                      <span>计划发货量：</span><span>{{item.supplyTransportGoodsVOList[0].amount}}{{item.supplyTransportGoodsVOList[0].amountUnitStr}}</span>
                    </van-col>
                    <van-col span="12" class="right">
                      <span>剩余委托数：</span><span>{{item.supplyTransportGoodsVOList[0].deposits}}{{item.supplyTransportGoodsVOList[0].amountUnitStr}}</span>
                    </van-col>
                    <van-col span="12">
                      <span>剩余运输数：</span><span>{{item.supplyTransportGoodsVOList[0].residualTransportation}}{{item.supplyTransportGoodsVOList[0].amountUnitStr}}</span>
                    </van-col>
                    <van-col span="24">
                      <span>服务要求：</span><span>{{item.supplyTransportGoodsVOList[0].tranRequire}}</span>
                    </van-col>
                  </van-row>
                </div>
              </template>
            </van-cell>
            <van-cell :border="false" class="item-ft" title="">
              <template #label>
                <div class="btn-box">
                  <router-link tag="span" :to="{ path: '/SendcarsOrder/'+item.id }">对应派车单</router-link>
                  <router-link tag="span" :to="{ path: '/TransportOrder/'+item.id }">对应运输单</router-link>
                </div>
              </template>
            </van-cell>
          </van-cell-group>
        </van-list>
        <van-empty v-else
          class="custom-image"
          :image="require('../../assets/img/no-content-img.png')"
        />
      </van-pull-refresh>
    </div>
</template>

<script>
export default {
  name: "InvoiceDetail",
  props: ['channel'],
  data() {
    return {
      svalue: '',
      status: '',
      activeId: '',
      list: [],
      nodata: false, // 是否有数据
      loading: false, // 是否上拉加载
      finished: false, // 上拉加载是否结束即加载全部数据
      isLoading: false, // 是否下拉刷新
      currentPage: 0, //页数
      showCount: 10 //每页个数
    }
  },
  created () {
    this.bId = this.$route.params.bId
    this.bus.$off()
    // 切换标签的对应id
    this.bus.$on('tabsId', (data) => {
      const { tabsId } = data
      this.activeId = tabsId
      this.currentPage = 1
      if (tabsId !== this.activeId) {
        return
      }
      this.nodata = false;
      this.finished = false;
      this.loading = true;
      this.currentPage = 1;
      this.list = [];
      this.getData();
    })
    // 监听搜索框
    this.bus.$on('svalue', (data) => {
      const { svalue } = data
      this.svalue = svalue
      this.nodata = false;
      this.finished = false;
      this.loading = true;
      this.currentPage = 1;
      this.list = [];
      this.getData();
    })
  },
  mounted() {
  },
  methods: {
    // 请求数据
    getData () {
      let status = this.activeId=='0'?'':this.activeId
      let bId = this.bId||'';
      let svalue = this.svalue||'';
      // this.$toast.loading({
      //   message: '加载中...',
      //   forbidClick: true,
      // });
      this.loading = true;
      this.isLoading = false;
      this.finished = false;
      let data = {
        num: svalue,  //发货单号
        bId: bId, //运输单id 查询运输单对应的发货单
        status: status, // 发货单状态 1未开始 2进行中 3已完成
        currentPage: this.currentPage, // 当前页数
        showCount: this.showCount ,//显示个数
      };
      // if(this.isLoading === true){
      //   this.loading = false
      // }
      this.$api.apis.supplyList(data).then(res => {
        this.loading = false
        if(res.flag !== '200') {
          this.nodata = true
          return false
        }
        this.totalResult = res.rsObj.page.totalResult
        res.rsObj.page.totalResult > 0 ? (this.nodata = false) : (this.nodata = true)
        this.list = this.list.concat(res.rsObj.supplyTransportDocumentsVOList)
        if (this.list.length >= this.totalResult && this.list.length !== 0) {
        	this.finished = true;
        }
        // this.currentPage += 1;
        // if(res&&res.rsObj&&res.rsObj.supplyTransportDocumentsVOList){
        //   this.list = this.list.concat(res.rsObj.supplyTransportDocumentsVOList)
        //   // 加载状态结束
        //   // console.log(this.list)
        //   this.loading = false
        //   if (res.rsObj.supplyTransportDocumentsVOList.length === 0||res.rsObj.supplyTransportDocumentsVOList.length<this.showCount ) {
        //     this.finished = true
        //   }
        // }else{
        //   this.finished = true
        //   this.loading = false
        //   this.nodata = false
        // }
        // this.isLoading = false
        // this.$toast.clear()
      });
    },
    // 下拉刷新
    onRefresh () {
      this.currentPage = 1;
      this.nodata = false;
      this.finished = false;
      this.list = [];
      this.getData();
      // this.$toast.success('刷新成功')
    },
    onLoad() {
      this.currentPage++
      this.getData();
    },
  },
  watch: {}
};
</script>
<style lang="less">
  @import '../../styles/order.less';
</style>



// WEBPACK FOOTER //
// src/components/List/InvoiceList.vue